import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const settingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-settings',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?',
};
